import { createContext } from 'react'

const VersionContext = createContext({
  version: typeof window !== `undefined` ? localStorage.getItem('version') : null,
  setVersion: () => false,
});

export default VersionContext